import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type Params = {
  projectId: number;
};

const { useGet: useProjectLearningOutcomes } = getCRUDHooks({
  entityName: 'projectLearningOutcomes',
  get: ({ projectId }: Params) =>
    clientApi.getOCClient().helpers.learningContent.projects.getLearningOutcomes(projectId),
});

export default useProjectLearningOutcomes;
